export default __webpack_public_path__ + "static/space_image-59ab967ff8d27b9f3c296029aa879e8b.png";